import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateDeleteVacancyList = {
  deleteVacancyList: { data: null, loading: false, error: null },
};

export const deleteVacancyList = createAsyncThunk('user/deleteVacancyList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/vacancies/active`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerDeleteVacancyList = {
  [deleteVacancyList.pending]: (state) => {
    state.deleteVacancyList.loading = true;
    state.deleteVacancyList.error = null;
  },
  [deleteVacancyList.fulfilled]: (state, action) => {
    state.deleteVacancyList.loading = false;
    state.deleteVacancyList.data = true;
    state.deleteVacancyList.error = null;
  },
  [deleteVacancyList.rejected]: (state, action) => {
    state.deleteVacancyList.loading = false;
    state.deleteVacancyList.error = action.payload;
  },
};
